import React, { useState } from "react";
import {
  Popover,
  Divider,
  createMuiTheme,
  MuiThemeProvider,
  Collapse,
  List,
  ListItem,
  ListItemText
} from "@material-ui/core";
import { ExpandLess, ExpandMore } from "@material-ui/icons";

import useStyles from "./styles";
import { langMap } from "../../inputData/inputContant";

const theme = createMuiTheme({
  overrides: {
    MuiPopover: {
      paper: {
        maxHeight: "242px"
      }
    }
  }
});

interface IMessageActions {
  actionOpen: any;
  callSetAction: any;
  callDictate: any;
  setTranslation: any;
  comprehend: any;
  anchorEl: any;
  setExpanded: any;
  addComment: any;
  messageData: any;
  setShare: any;
  setExpert: any;
  setSponsorData: any;
  PermissionData: any;
}

const MessageActions: React.FC<IMessageActions> = ({
  actionOpen,
  callSetAction,
  callDictate,
  setTranslation,
  comprehend,
  anchorEl,
  PermissionData,
  setExpanded,
  addComment,
  messageData,
  setShare,
  setExpert,
  setSponsorData
}) => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);
  const [sponsorOpen, setSponsorOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const sponsorHandleClick = () => {
    setSponsorOpen(!sponsorOpen);
  };

  return (
    <MuiThemeProvider theme={theme}>
      <Popover
        id="simple-popper"
        open={actionOpen}
        anchorEl={anchorEl}
        onClose={() => callSetAction()}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        transformOrigin={{ vertical: "top", horizontal: "center" }}
      >
        {PermissionData &&
        PermissionData.Permissions.indexOf("textToSpeech") > -1 ? (
          <ListItem button onClick={() => callDictate()}>
            <ListItemText primary="Text to Speech" />
          </ListItem>
        ) : (
          ""
        )}
        <Divider />
        {/* <ListItemText primary="Conversation Boosters" style={{marginLeft:'8px', marginRight:"8px"}} />
        <Divider /> */}
        {PermissionData &&
        PermissionData.Permissions.indexOf("translate") > -1 ? (
          <ListItem button onClick={handleClick}>
            <ListItemText primary="Translate" />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
        ) : (
          ""
        )}
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List disablePadding>
            {langMap.map(l => (
              <ListItem
                button
                className={classes.nested}
                onClick={() => {
                  setTranslation(l.code);
                }}
              >
                <ListItemText primary={l.lang} />
              </ListItem>
            ))}
          </List>
        </Collapse>
        <Divider />
        {/* <ListItem button onClick={() => setExpert()}> */}
        {/* <ListItem button>
          <ListItemText primary="Experts" />
        </ListItem>
        <Divider />
        <ListItem button onClick={sponsorHandleClick}>
          <ListItemText primary="Sponsors" />
          {sponsorOpen ? <ExpandLess /> : <ExpandMore />}
        </ListItem>
        <Collapse in={sponsorOpen} timeout="auto" unmountOnExit>
          <List disablePadding>
            {setSponsorData && setSponsorData.map((l: any) => (
              <a href={l.link} style={{ color: "black" }} target="_blank">
                <ListItem key={l.link}>
                  {l.name}
                  <Divider />
                </ListItem>
              </a>
            ))}
          </List>
        </Collapse> */}
        {/* <Divider />
        <ListItem button onClick={() => addComment()}>
            <ListItemText primary="Comment" />
        </ListItem> */}
        {/* <Divider />
        <ListItem button onClick={() => setShare()}>
            <ListItemText primary="Share" />
        </ListItem> */}
      </Popover>
    </MuiThemeProvider>
  );
};

export default MessageActions;
